export default [
  {
    path: '/app/customers/prices',
    name: 'Prices',
    component: () => import('@/views/Admin/Customer_prices/Index.vue'),
    meta: {
      pageTitle: 'Fiyat Listesi',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_PRICE_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/customers/prices/customer-search',
    name: 'PriceCustomerSearch',
    component: () => import('@/views/Admin/Customer_prices/CustomerSearch.vue'),
    meta: {
      pageTitle: 'Fiyat Listesi',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/customers/prices',
          active: false,
        },
        {
          text: 'Müşteri Arama',
          active: true,
        },
      ],
      resource: 'ADMIN_PRICE_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/customers/prices/add/:id_customers',
    name: 'PriceAdd',
    component: () => import('@/views/Admin/Customer_prices/Add.vue'),
    meta: {
      pageTitle: 'Fiyat Listesi',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/customers/prices',
          active: false,
        },
        {
          text: 'Müşteri Arama',
          to: '/app/customers/prices/customer-search',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_PRICE_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/customers/prices/edit/:id',
    name: 'PriceEdit',
    component: () => import('@/views/Admin/Customer_prices/Edit.vue'),
    meta: {
      pageTitle: 'Fiyat Listesi',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/customers/prices',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_PRICE_EDIT',
      action: 'read',
    },
  },
]
